import { Outlet } from "react-router-dom";
import { Stack, styled } from "@mui/material";

export const MatchLayout = () => {
  return (
    <MatchLayoutWrapper>
      <Outlet />
    </MatchLayoutWrapper>
  );
};

const MatchLayoutWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
